"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAGING_JEFF_REPORT_SERVICE_TOKEN_CONTEXT = void 0;
exports.isStagingJeffEnvironment = isStagingJeffEnvironment;
// Staging-Jeff intentionally derives this service credential from its shared
// Stytch secret. That coupling is accepted only for the isolated preview.
exports.STAGING_JEFF_REPORT_SERVICE_TOKEN_CONTEXT = "newform.report-service.staging-jeff.v1";
/** Exact isolated preview environment; a named environment always wins. */
function isStagingJeffEnvironment(environment) {
    var _a, _b;
    const environmentName = (_a = environment.railwayEnvironmentName) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
    const branch = (_b = environment.railwayGitBranch) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase();
    return (environmentName === "staging-jeff" ||
        (!environmentName && branch === "staging-jeff"));
}
